(() => {
  const diy = document.querySelector('.hhc-diy-page');
  const formHost = diy?.querySelector('.globo-formbuilder[data-id="MTE2MjAz"]');
  const dimensionName = text => {
    const match = text.match(/\b(5|6|13)\s*["″]?\s*[x×]\s*["″]?\s*(4|5|6)\b/i);
    return match ? match[1] + ' × ' + match[2] : null;
  };
  const repairForm = () => {
    if (!formHost) return;
    for (const input of formHost.querySelectorAll('input[type="radio"]')) {
      const labels = [...(input.labels || [])];
      const parent = input.parentElement;
      if (!labels.length && parent?.querySelectorAll('input[type="radio"]').length === 1) labels.push(parent);
      const name = labels.map(label => dimensionName(label.textContent || '')).find(Boolean);
      if (name && input.getAttribute('aria-label') !== name) input.setAttribute('aria-label', name);
    }
    const walker = document.createTreeWalker(formHost, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.nodeValue.trim() === 'Prefered Product') node.nodeValue = node.nodeValue.replace('Prefered Product', diy.dataset.hhcPreferredProduct);
    }
  };
  const refresh = repairForm;
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refresh(); });
  });
  const observe = () => observer.observe(document.body, { childList: true, subtree: true });
  observe();
  refresh();
  window.addEventListener('pagehide', () => observer.disconnect());
  window.addEventListener('pageshow', () => { observe(); refresh(); });
})();
